<div class="container-toggle p-1">
  <div class="row gx-1 flex-nowrap align-items-center h-100">
    <div *ngFor="let view of listViews"
        class="col-auto">
      <button class="btn btn-icon d-flex align-items-center text-gray-pantone p-1 h-100"
          title="{{ view.name }}"
          type="button"
          [class.active]="selected === view.value"
          (click)="onViewChange(view.value)">
        <svg height="16"
            width="16"
            stroke="currentColor">
          <use height="16"
              width="16"
              [attr.href]="view.iconPath">
          </use>
        </svg>
      </button>
    </div>
  </div>
</div>